import React from 'react';
import { useQuery } from '@apollo/client';

import CategoriesFilters from './categories-filters';

import query, { CategoriesFiltersQuery } from './categories-filters.graphql';

export interface Props {
    initialCountiesValue?: string | string[];
    initialPriceValue?: string;
    confirmCounty: (countyIds: string[]) => void;
    confirmPrice: (prices: string[]) => void;
    clearCounty: () => void;
    clearPrice: () => void;
}

const CategoriesFiltersLoader: React.FC<Props> = props => {
    const { data } = useQuery<CategoriesFiltersQuery>(query);

    return data?.counties?.edges.length ? <CategoriesFilters counties={data.counties} {...props} /> : null;
};

export default CategoriesFiltersLoader;
